module.exports = __webpack_public_path__ + "static/media/student_icon_yellow.1ba2fdb1.svg";